import * as React from 'react';
import { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import DialogContentText from '@mui/material/DialogContentText';

import CloseIcon from '@mui/icons-material/Close';
import PersonIcon from '@mui/icons-material/Person';
import DateRangeIcon from '@mui/icons-material/DateRange';
import LogoutIcon from '@mui/icons-material/Logout';
import SettingsIcon from '@mui/icons-material/Settings';

import Slide from '@mui/material/Slide';
import supabase from '../supabase';

import ListItemText from '@mui/material/ListItemText';
import ListItemButton from '@mui/material/ListItemButton';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import { TransitionProps } from '@mui/material/transitions';
import { Drawer } from '@mui/material';

import MDBoxRoot from './MDBox/MDBoxRoot';
import MDTypographyRoot from './MDTypography/MDTypographyRoot';
import MDButtonRoot from './MDButton/MDButtonRoot';
import MDdrawer from './MDDrawer/MDdrawer';
import MDDialogs from './MDDialog/MDDialogs';


{/*const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide in={isChecked} 
    container={containerRef.current} direction='left'>
  });*/}

const TransitionEnter = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: React.ReactElement;
  },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="left" ref={ref} timeout={{ enter: 300, exit: 300 }} {...props} />;
});

const TransitionExit = React.forwardRef(function Transition(
  props: TransitionProps & { children: React.ReactElement },
  ref: React.Ref<unknown>,
) {
  return <Slide direction="right" ref={ref} timeout={{ enter: 300, exit: 300 }} {...props} />;
});

{/*function TransitionExit (props: TransitionProps & { children?: React.ReactElement }) {return (
    <Slide direction="right" timeout={{ enter: 200000, exit: 2000 }}{...props}>{props.children}</Slide>
 );}
  onExit: () => (props: TransitionProps & { children?: React.ReactElement }) => (
          <Slide direction="right" timeout={{ enter: 200000, exit: 2000 }} {...props}>{props.children}</Slide>
        )}} 
  */}


const RightSideProfile = ({ onClose }) => {

  const signOut = async () => {
    const { error } = await supabase.auth.signOut();
    return false;
  }
  return (<>
    <Dialog
      open={true}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      TransitionComponent={TransitionEnter}
      TransitionProps={{
        mountOnEnter: true,
        unmountOnExit: true,
        onExit: () => TransitionExit
      }}
      sx={{ left: "initial", right: "0" }}
    >

      <MDDialogs variant="permanent" ownerState={{
        transparentSidenav: false,
        color: "info",
        whiteSidenav: true
      }}
        ownerloyaut={{ br: "8px" }}
      //() => {}
      >
        <MDButtonRoot
          ownerState={{
            size: "small",
            variant: "",
            color: "info",
            textTransform: "none",
            circular: false,
            iconOnly: true,
            darkMode: false
          }}
          sx={{ position: "absolute", top: "10px", right: "10px" }}
          onClick={onClose} startIcon={<CloseIcon />}
        />
        <MDBoxRoot
          display="flex"
          justifyContent="space-between"
          alignItems="baseline"
          flexDirection="column"
          pt={4}
          pb={0.5}
          px={3}
        >
          <MDBoxRoot mt={2} lineHeight={1} display="flex"
            justifyContent="space-between"
            alignItems="baseline">
            <MDTypographyRoot variant="h6" px={1}><PersonIcon fontSize="small" /></MDTypographyRoot>
            <MDTypographyRoot variant="button" color="text">
              <a>Profile</a>
            </MDTypographyRoot>
          </MDBoxRoot>
          <MDBoxRoot mt={2} lineHeight={1} display="flex"
            justifyContent="space-between"
            alignItems="baseline">
            <MDTypographyRoot variant="h6" px={1}><DateRangeIcon fontSize="small" /></MDTypographyRoot>
            <MDTypographyRoot variant="button" color="text">
              <a>Your Instructor Schedule</a>
            </MDTypographyRoot>
          </MDBoxRoot>
          <MDBoxRoot mt={2} lineHeight={1} display="flex"
            justifyContent="space-between"
            alignItems="baseline">
            <MDTypographyRoot variant="h6" px={1}><SettingsIcon fontSize="small" /></MDTypographyRoot>
            <MDTypographyRoot variant="button" color="text">
              <a>Settings</a>
            </MDTypographyRoot>
          </MDBoxRoot>
          <MDBoxRoot mt={2} lineHeight={1} display="flex"
            justifyContent="space-between"
            alignItems="baseline">
            <MDTypographyRoot variant="h6" px={1}><LogoutIcon fontSize="small" /></MDTypographyRoot>
            <MDTypographyRoot variant="button" color="text" onClick={signOut} sx={{cursor: "alias"}}>
              <a>Sign Out</a>
            </MDTypographyRoot>
          </MDBoxRoot>


          {/*<DialogContent>
          <DialogContentText id="alert-dialog-description">

            <div className='row set-padding-bottom'>
                <div className='set-padding-top'><PersonIcon fontSize="small"/></div>
                <div className='colum-80'><a>Your Profile</a></div></div>
                <div className='row set-buttom-line'></div>
            <div className='row set-padding-bottom set-padding-top'>
                <div className='set-padding-top'><DateRangeIcon fontSize="small"/></div>
                <div className='colum-80'><a>Your Scheduel</a></div></div>
                <div className='row set-buttom-line'></div>
            <div className='row set-padding-bottom set-padding-top'>
                <div className='set-padding-top'><SettingsIcon fontSize="small"/></div>
                <div className='colum-80'><a>Settings</a></div></div>
                <div className='row set-buttom-line'></div>
            <div className='row set-padding-bottom set-padding-top'>
                <div className='set-padding-top'><LogoutIcon fontSize="small"/></div>
                <div className='colum-80'><a onClick={signOut}>Sign Out</a></div></div>
                

          </DialogContentText>
  </DialogContent>*/}
          <DialogActions>


          </DialogActions>
        </MDBoxRoot> </MDDialogs>
    </Dialog>

  </>
  )
}

export default RightSideProfile;
